import React from "react";

const LoadingState = ({ label = "Loading…", className = "" }) => (
  <div className={`state ${className}`} role="status" aria-live="polite">
    <div className="spin" aria-hidden="true" />
    <p className="state__desc" style={{ marginTop: 8 }}>{label}</p>
  </div>
);

export default LoadingState;
